import {
  getAction,
  deleteAction,
  putAction,
  postAction
} from '@/api/manage'

//角色管理
const addRole = (params) => postAction("/blaze-sys/k00/k0003/RoleManage/add", params);
const editRole = (params) => putAction("/blaze-sys/k00/k0003/RoleManage/edit", params);

//职位管理
const queryPost = (params) => getAction("/blaze-sys/k00/k0009/PositionManage/queryall", params);

//用户管理
const addUser = (params) => postAction("/blaze-sys/k00/k0014/UserManage/add", params);
const editUser = (params) => putAction("/blaze-sys/k00/k0014/UserManage/edit", params);
const frozenBatch = (params) => putAction("/blaze-sys/k00/k0014/UserManage/frozenBatch", params);

//权限管理
const addPermission = (params) => postAction("/blaze-sys/k00/k0005/MenuManage/add", params);
const editPermission = (params) => putAction("/blaze-sys/k00/k0005/MenuManage/edit", params);
const getPermissionList = (params) => getAction("/blaze-sys/k00/k0005/MenuManage/list", params);

const queryTreeList = (params) => getAction("/blaze-sys/k00/k0005/MenuManage/queryTreeList", params);
const queryTreeListForRole = (params) => getAction("/blaze-sys/k00/k0003/RoleManage/queryTreeList", params);
const queryPermissionsByUser = (params) => getAction("/blaze-sys/k00/k0005/MenuManage/getUserPermissionByToken", params);

// 部门管理
const queryDepartTreeList = (params) => getAction("/blaze-sys/k00/k0002/DepartManage/queryTreeList", params);
const queryIdTree = (params) => getAction("/blaze-sys/k00/k0002/DepartManage/queryIdTree", params);
const searchByKeywords = (params) => getAction("/blaze-sys/k00/k0002/DepartManage/searchBy", params);
const deleteByDepartId = (params) => deleteAction("/blaze-sys/k00/k0002/DepartManage/delete", params);

//数据字典
const addDict = (params) => postAction("/blaze-sys/k00/k0006/DictManage/add", params);
const editDict = (params) => putAction("/blaze-sys/k00/k0006/DictManage/edit", params);
const treeList = (params) => getAction("/blaze-sys/k00/k0006/DictManage/treeList", params);
const addDictItem = (params) => postAction("/blaze-sys/k00/k0006/DictItemManage/add", params);
const editDictItem = (params) => putAction("/blaze-sys/k00/k0006/DictItemManage/edit", params);

//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/blaze-sys/k00/k0006/DictManage/getDictItems/${code}`, params);

// 根据部门主键查询用户信息
const queryUserByDepId = (params) => getAction("/blaze-sys/k00/k0014/UserManage/queryUserByDepId", params);

// 重复校验
const duplicateCheck = (params) => getAction("/blaze-sys/sys/duplicate/check", params);
// 加载分类字典
const checkRuleByCode = (params) => getAction('/blaze-sys/sys/checkRule/checkByCode', params)

export {
  // imgView,
  // doMian,
  addRole,
  editRole,
  addUser,
  editUser,
  queryPost,
  frozenBatch,
  getPermissionList,
  addPermission,
  editPermission,
  queryTreeList,
  queryPermissionsByUser,
  queryDepartTreeList,
  queryIdTree,
  searchByKeywords,
  deleteByDepartId,
  addDict,
  editDict,
  treeList,
  addDictItem,
  editDictItem,
  queryUserByDepId,
  duplicateCheck,
  queryTreeListForRole,
  checkRuleByCode,
}